
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import Home from '@/pages/Home';
import CategoriesPage from '@/pages/CategoriesPage';
import CategoryPage from '@/pages/CategoryPage';
import GameDetail from '@/pages/GameDetail';
import SearchPage from '@/pages/SearchPage';
import TrendingPage from '@/pages/TrendingPage';
import NewGamesPage from '@/pages/NewGamesPage';
import AboutPage from '@/pages/AboutPage';
import ContactPage from '@/pages/ContactPage';
import PrivacyPage from '@/pages/PrivacyPage';
import TermsPage from '@/pages/TermsPage';
import BlogPage from '@/pages/BlogPage';
import BlogPostPage from '@/pages/BlogPostPage';
import CustomPage from '@/pages/CustomPage';
import NotFound from '@/pages/NotFound';

// Admin pages
import AdminLogin from '@/pages/admin/AdminLogin';
import AdminDashboard from '@/pages/admin/AdminDashboard';
import AdminGames from '@/pages/admin/AdminGames';
import AdminGamesFeed from '@/pages/admin/AdminGamesFeed';
import AdminCategories from '@/pages/admin/AdminCategories';
import AdminBlog from '@/pages/admin/AdminBlog';
import AdminPages from '@/pages/admin/AdminPages';
import AdminMenus from '@/pages/admin/AdminMenus';
import AdminAds from '@/pages/admin/AdminAds';
import AdminSEO from '@/pages/admin/AdminSEO';
import AdminSitemaps from '@/pages/admin/AdminSitemaps';
import AdminUsers from '@/pages/admin/AdminUsers';
import AdminAnalytics from '@/pages/admin/AdminAnalytics';
import AdminSettings from '@/pages/admin/AdminSettings';

// Admin components
import AdminLayout from '@/components/admin/AdminLayout';
import AuthGuard from '@/components/admin/AuthGuard';
import EnhancedSecurityWrapper from '@/components/admin/EnhancedSecurityWrapper';

// SEO components
import SitemapRoute from '@/components/seo/SitemapRoute';

const RoutesWrapper = () => {
  return (
    <Routes>
      {/* Public routes with header and footer */}
      <Route path="/" element={
        <>
          <Header />
          <main className="flex-1">
            <Home />
          </main>
          <Footer />
        </>
      } />
      
      <Route path="/categories" element={
        <>
          <Header />
          <main className="flex-1">
            <CategoriesPage />
          </main>
          <Footer />
        </>
      } />
      
      <Route path="/category/:categorySlug" element={
        <>
          <Header />
          <main className="flex-1">
            <CategoryPage />
          </main>
          <Footer />
        </>
      } />
      
      {/* Game routes - handle both slug-only and ID+slug patterns */}
      <Route path="/game/:gameSlug" element={
        <>
          <Header />
          <main className="flex-1">
            <GameDetail />
          </main>
          <Footer />
        </>
      } />
      
      <Route path="/game/:gameId/:gameSlug?" element={
        <>
          <Header />
          <main className="flex-1">
            <GameDetail />
          </main>
          <Footer />
        </>
      } />
      
      <Route path="/search" element={
        <>
          <Header />
          <main className="flex-1">
            <SearchPage />
          </main>
          <Footer />
        </>
      } />
      
      <Route path="/trending" element={
        <>
          <Header />
          <main className="flex-1">
            <TrendingPage />
          </main>
          <Footer />
        </>
      } />
      
      <Route path="/new" element={
        <>
          <Header />
          <main className="flex-1">
            <NewGamesPage />
          </main>
          <Footer />
        </>
      } />
      
      <Route path="/about" element={
        <>
          <Header />
          <main className="flex-1">
            <AboutPage />
          </main>
          <Footer />
        </>
      } />
      
      <Route path="/contact" element={
        <>
          <Header />
          <main className="flex-1">
            <ContactPage />
          </main>
          <Footer />
        </>
      } />
      
      <Route path="/privacy" element={
        <>
          <Header />
          <main className="flex-1">
            <PrivacyPage />
          </main>
          <Footer />
        </>
      } />
      
      <Route path="/terms" element={
        <>
          <Header />
          <main className="flex-1">
            <TermsPage />
          </main>
          <Footer />
        </>
      } />
      
      <Route path="/blog" element={
        <>
          <Header />
          <main className="flex-1">
            <BlogPage />
          </main>
          <Footer />
        </>
      } />
      
      {/* Updated blog post route to handle URL-encoded slugs */}
      <Route path="/blog/:postSlug" element={
        <>
          <Header />
          <main className="flex-1">
            <BlogPostPage />
          </main>
          <Footer />
        </>
      } />
      
      <Route path="/page/:slug" element={
        <>
          <Header />
          <main className="flex-1">
            <CustomPage />
          </main>
          <Footer />
        </>
      } />

      {/* SEO routes */}
      <Route path="/sitemap.xml" element={<SitemapRoute />} />
      <Route path="/sitemap-:type.xml" element={<SitemapRoute />} />

      {/* Admin routes without header/footer - RESTORED PORTAL PATH */}
      <Route path="/admin/portal" element={<AdminLogin />} />
      
      <Route path="/admin/*" element={
        <AuthGuard>
          <EnhancedSecurityWrapper>
            <AdminLayout>
              <Routes>
                <Route path="dashboard" element={<AdminDashboard />} />
                <Route path="games" element={<AdminGames />} />
                <Route path="games-feed" element={<AdminGamesFeed />} />
                <Route path="categories" element={<AdminCategories />} />
                <Route path="blog" element={<AdminBlog />} />
                <Route path="pages" element={<AdminPages />} />
                <Route path="menus" element={<AdminMenus />} />
                <Route path="ads" element={<AdminAds />} />
                <Route path="seo" element={<AdminSEO />} />
                <Route path="sitemaps" element={<AdminSitemaps />} />
                <Route path="users" element={<AdminUsers />} />
                <Route path="analytics" element={<AdminAnalytics />} />
                <Route path="settings" element={<AdminSettings />} />
              </Routes>
            </AdminLayout>
          </EnhancedSecurityWrapper>
        </AuthGuard>
      } />

      {/* 404 route */}
      <Route path="*" element={
        <>
          <Header />
          <main className="flex-1">
            <NotFound />
          </main>
          <Footer />
        </>
      } />
    </Routes>
  );
};

export default RoutesWrapper;
